<template>
  <v-dialog
    v-model="active"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="headline">
        {{title}}
      </v-card-title>
      <v-card-text>
        {{message}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="handleCancel"
        >
          {{cancelLabel ? cancelLabel : 'Não'}}
        </v-btn>
        <v-btn
          color="primary"
          dark
          @click="handleConfirm"
        >
          {{confirmLabel ? confirmLabel : 'Sim'}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['active', 'title', 'message', 'handleConfirm', 'handleCancel', 'confirmLabel', 'cancelLabel']
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/ConfirmationModal.vue